/* eslint-disable react-hooks/exhaustive-deps */
import Dropzone from 'react-dropzone';
import { Fragment, useCallback, useMemo, useState } from 'react';
import { without } from 'lodash-es';

import { collection, doc, setDoc } from 'firebase/firestore';

import { ref, uploadBytes } from 'firebase/storage';

import classNames from 'classnames';

import * as styles from '../../components/Layout/Layout.module.css';

import ImportIcon from '../../images/iconBIG_import_NEW.svg';
import ReleaseIcon from '../../images/iconBIG_import_release.svg';
import { FileEntry, FilesContext } from '../../components/Files/Files';
import { createHash } from '../../utils/sign-helpers';
import {
  FastAnimation,
  SlowAnimation,
} from '../../components/Animation/Animation';
import { isDidmultiSign } from '../../utils/verify-helper';
import { SigningMultipleDidFiles } from '../../components/Popups/Popups';
import { SignatureContext } from '../../components/Signature/Signature';
import { Navigation } from '../../components/Navigation/Navigation';
import { FilesEmpty } from '../../components/FilesEmpty/FilesEmpty';
import { SignedFiles } from '../../components/SignedFiles/SignedFiles';

import { Signature } from '../../utils/types';
import { InfoLink } from '../../components/BottomSection/InfoLink';
import { useBooleanState } from '../../hooks/useBooleanState';
import { firestore, storage } from '../../utils/firebase';

export function Home() {
  const [loading, setLoading] = useState(false);
  const [uniqueId, setUniqueId] = useState<string>('');
  const dragging = useBooleanState();
  const icon = dragging.current ? ReleaseIcon : ImportIcon;
  const signErrorPopup = useBooleanState();
  const [signers, setSigners] = useState<{ did: string; email: string }[]>([]);
  const [didValue, setDidValue] = useState<string>('');
  const [emailValue, setEmailValue] = useState<string>('');
  const [contractName, setContrsactName] = useState<string>('');

  const [files, setFiles] = useState<FileEntry[]>([]);
  const filesContext = useMemo(() => ({ files, setFiles }), [files]);

  const [signatureValues, setSignature] = useState<Signature>({});
  const signatureContext = useMemo(
    () => ({ ...signatureValues, setSignature }),
    [signatureValues],
  );
  const { signature, timestamped, downloaded } = signatureValues;

  const handleDrop = useCallback(
    async (acceptedFiles: File[]) => {
      if (signature) {
        const didmultiSign = files.find(isDidmultiSign);
        if (!didmultiSign) return;

        setFiles((files) => without(files, didmultiSign));
        setSignature({});
      }
      acceptedFiles.forEach(async (file: File) => {
        dragging.off();

        const { name } = file;
        if (isDidmultiSign(file)) {
          signErrorPopup.on();
          return;
        }
        const buffer = await file.arrayBuffer();
        const hash = await createHash(buffer);
        setFiles((files) => [...files, { file, buffer, name, hash }]);
      });
    },
    [dragging, files, signErrorPopup, signature],
  );

  const createMultisign = async () => {
    setLoading(true);

    const [contract] = files;
    const _uniqueId = Math.random().toString(36).substr(2, 9);
    const storageRef = ref(
      storage,
      `${_uniqueId}/${contractName}.file.${contract.name.split('.').pop()}`,
    );

    const [{ did: creatorDid }] = await window.kilt.sporran.getDidList();

    await uploadBytes(storageRef, contract.file);

    await setDoc(doc(collection(firestore, 'multisign'), _uniqueId), {
      signers,
      contractName,
      creatorDid,
    });

    signers.map(({ email, did }) => {
      setDoc(doc(collection(firestore, 'mail')), {
        to: email,
        message: {
          subject: 'Multisign contract created',
          html: `<p>Hi</p><p>Creator with DID: ${creatorDid} ... </p><br /><p>Sign: <a href="https://multisign.vercel.app/signer?multiSign=${_uniqueId}">https://multisign.vercel.app/signer?multiSign=${_uniqueId}</a></p><p>Verify: <a href="https://multisign.vercel.app/verifier?multiSign=${_uniqueId}&did=${did}">https://multisign.vercel.app/verifier?multiSign=${_uniqueId}&did=${did}</a></p>`,
        },
      });
    });

    alert('Multisign contract created successfully');

    setLoading(false);

    setUniqueId(_uniqueId);
  };

  const handleAddSigner = () => {
    if (
      !didValue.includes('did:kilt:') ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)
    )
      return alert('Not valid signer');

    const newSigners = [...signers, { did: didValue, email: emailValue }];

    setSigners(newSigners);

    setDidValue('');
    setEmailValue('');
  };

  return (
    <FilesContext.Provider value={filesContext}>
      <SignatureContext.Provider value={signatureContext}>
        <main className={styles.main}>
          <Navigation needWarning={timestamped && !downloaded} />

          <section
            className={classNames(styles.bottomContainer, styles.signersForm)}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
              <p style={{ display: 'flex', flexDirection: 'column' }}>
                Contract name:{' '}
                <input
                  defaultValue={contractName}
                  onChange={(e) => setContrsactName(e.target.value)}
                  placeholder=""
                />
              </p>

              <div>
                <p style={{ margin: 0 }}>Signers:</p>
                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    alignItems: 'flex-end',
                    justifyContent: 'center',
                  }}
                >
                  <p
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: 0,
                    }}
                  >
                    DID:{' '}
                    <input
                      placeholder="did:kilt:4qpq9..."
                      value={didValue}
                      onChange={(e) => setDidValue(e.target.value)}
                    />
                  </p>
                  <p
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: 0,
                    }}
                  >
                    email:{' '}
                    <input
                      placeholder="foo@bar.xyz"
                      value={emailValue}
                      onChange={(e) => setEmailValue(e.target.value)}
                    />
                  </p>
                  <button onClick={handleAddSigner}>Add</button>
                </div>
              </div>
            </div>

            <br />

            {signers.map((a, i) => (
              <p
                key={i}
                style={{
                  minWidth: '700px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '15px',
                }}
              >
                {JSON.stringify(a)}{' '}
                <button
                  onClick={() => {
                    const newSigners = [...signers];

                    setSigners(newSigners.filter((_, _i) => _i !== i));
                  }}
                >
                  X
                </button>
              </p>
            ))}

            <div style={{ marginBottom: '80px' }} />

            <div className={styles.middleSection}>
              <div className={styles.container}>
                <Dropzone
                  onDrop={handleDrop}
                  onDragEnter={dragging.on}
                  onDragLeave={dragging.off}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className={styles.dropContainer} {...getRootProps({})}>
                      {dragging.current ? <FastAnimation /> : <SlowAnimation />}

                      <input {...getInputProps()} />
                      <img className={styles.importIcon} src={icon} alt="" />

                      {!dragging.current && (
                        <Fragment>
                          <span className={styles.signText}>
                            Upload Your Files
                          </span>
                          <span className={styles.dragDropText}>
                            drag & drop
                          </span>
                          <span className={styles.browseFilesText}>
                            or click / tap to browse your files
                          </span>
                        </Fragment>
                      )}
                    </div>
                  )}
                </Dropzone>

                {signErrorPopup.current && (
                  <SigningMultipleDidFiles onDismiss={signErrorPopup.off} />
                )}
              </div>

              {files.length === 0 ? <FilesEmpty /> : <SignedFiles />}
            </div>

            <div className={styles.bottomSection}>
              <button
                disabled={
                  !contractName || files.length === 0 || signers.length === 0
                }
                onClick={createMultisign}
              >
                {loading ? 'loading...' : 'Create Multisign'}
              </button>
              {uniqueId && `Multisign contract created with id: ${uniqueId}`}
            </div>
            <InfoLink />
          </section>
        </main>
      </SignatureContext.Provider>
    </FilesContext.Provider>
  );
}
